import React, { createContext, useContext, useState, useCallback } from "react";

const en = {
    book_appointment: "Book an Appointment",
    home: "Home", about: "About", conditions: "Conditions", treatments: "Treatments",
    patient_education: "Patient Education", research: "Research", contact: "Contact",
    learn_more: "Learn More",
    follow: "Follow for Urology Education",
    tamil_notice: "Tamil translation is being prepared. Content is currently shown in English.",
};

const LanguageContext = createContext({ lang: "en", t: (k) => en[k] || k });

export function LanguageProvider({ children }) {
    const [lang] = useState("en");
    const t = useCallback((key) => en[key] || key, []);
    return (
        <LanguageContext.Provider value={{ lang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => useContext(LanguageContext);
